module.exports = __webpack_public_path__ + "img/EditNote.b6bd2b51.svg";